import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { AxlButton, AxlModal, AxlPopConfirm } from "axl-reactjs-ui";
import { images } from "../../constants/images";
import Slider from "react-slick";
import _ from "lodash";

// Utils
import {
  DROPOFF_SUCCEEDED,
  DROPOFF_FAILED,
} from "../../constants/shipmentStatus";
import {openTrackingLink} from "../../utils/common";

// Components
import ShipmentInfo from "../../components/ShipmentInfo/";
import ShipmentCancel from "../../components/ShipmentCancel";
import { downloadPdf } from "../../utils/pdf";
import styles, * as E from "./styles";
import moment from "moment";
import ShipmentFeedback from "../../components/ShipmentFeedback";
import ShipmentClone from "../../components/ShipmentClone";
import ShipmentPODModal from "../../components/ShipmentPODModal";

@inject("shipmentStore", "deliveryStore", "userStore")
@observer
class ShipmentDetail extends Component {
  constructor(props) {
    super(props);
    const { shipmentId } = props;
    this.getShipment(shipmentId);
    this.state = {
      showShipmentPicture: false,
      showSignaturePicture: false,
      showImageUploadPreView: false,
      showCancelShipment: false,
      showFeedback: false,
      showClone: false,
    };
  }

  getShipment(shipmentId) {
    const { shipmentStore, deliveryStore } = this.props;
    shipmentStore.getShipment(shipmentId).then((s) => {
      deliveryStore.setSelectedShipment(s.data);
      shipmentStore.getShipmentStops();
      shipmentStore.getShipmentPOD();
    });
  }

  componentWillReceiveProps(props) {
    if (props.shipmentId !== this.props.shipmentId) {
      if (props.shipmentId) {
        this.getShipment(props.shipmentId);
      }
    }
  }

  download = (format) => (e) => {
    const { shipmentStore, deliveryStore } = this.props;
    const { selectedShipment } = deliveryStore;

    if (!selectedShipment) return;
    downloadPdf(shipmentStore, selectedShipment.id, format);
  };

  addImage = (shipmentId) => (file) => {
    const { shipmentStore, history } = this.props;
    shipmentStore.addImage(shipmentId, file, (image) => {
      this.setState({ showImageUploadPreView: false });
    });
  };

  showCancelShipmentModal = () => {
    this.setState({ showCancelShipment: true });
  };

  hideCancelShipmentModal = () => {
    this.setState({ showCancelShipment: false });
  };

  hideFeedbackModal = () => {
    this.setState({ showFeedback: false });
  };

  hideCloneModal = () => {
    this.setState({ showClone: false });
  };

  getPodCategoryColor = (category) => {
    if (category === "OUTBOUND") {
      return "orange";
    }

    return "green";
  }

  render() {
    const { shipmentStore, deliveryStore, userStore, isBlur } = this.props;
    const {
      showShipmentPicture, showSignaturePicture, showCancelShipment,
      showFeedback, showClone,
    } = this.state;
    const { activeShipment } = shipmentStore;
    const { clientSettings } = deliveryStore;

    if (!activeShipment || (activeShipment && !activeShipment.data)) {
      return <div />;
    }

    const { stops = [], data, pod } = activeShipment;
    const shipment = data;
    let dd = stops.filter ? stops.filter((s) => s.type === "DROP_OFF") : [];
    let pp = stops.filter ? stops.filter((s) => s.type === "PICK_UP"): [];
    dd = _.sortBy(dd, (drop) => -moment(drop.actual_departure_ts));
    pp = _.sortBy(pp, (pick) => -moment(pick.actual_departure_ts));
    const dropoff = dd.length > 0 ? dd[0] : null;
    const pickup = pp.length > 0 ? pp[0] : null;
    let info = shipment ? shipment : null;
    let stop_images = pod && pod.images ? pod.images : [];
    let stop_signatures = pod && pod.signatures ? pod.signatures : [];
    let images_count = info ? stop_images.length : "-";
    let signatures_count = info ? stop_signatures.length : "-";
    const { customer } = shipment;
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SliderNextArrow />,
      prevArrow: <SliderPrevArrow />,
    };
    const isAvaiableCancel =
      !userStore.isReadOnly &&
      [DROPOFF_SUCCEEDED].indexOf(shipment.status) === -1;
    let allowClone = false;
    if (
      !!clientSettings.client_settings &&
      !!clientSettings.client_settings.settings &&
      clientSettings.client_settings.settings.allow_clone === "true"
    ) {
      allowClone = true;
    }

    return (
      <div style={{ ...styles.container, ...this.style }}>
        <div style={styles.body}>
          <ShipmentInfo
            shipment={shipment}
            client={customer}
            dropoff={dropoff}
            pickup={pickup}
            shipmentHistory={activeShipment.history}
            isBlur={isBlur}
          />
        </div>
        <E.FooterContainer style={styles.footer}>
          <div style={styles.groupButtons}>
            <AxlButton
              bg={"white"}
              compact={true}
              source={images.icon.camera}
              style={{ margin: "0px -1px", padding: "0", width: "60px" }}
              onClick={() =>
                images_count > 0 && this.setState({ showShipmentPicture: true })
              }
            >
              {images_count}
            </AxlButton>
            <AxlButton
              bg={"white"}
              compact={true}
              source={images.icon.edit}
              style={{ margin: "0px -1px", padding: 0 }}
              onClick={() =>
                signatures_count > 0 &&
                this.setState({ showSignaturePicture: true })
              }
            >
              {signatures_count}
            </AxlButton>
          </div>
          {[DROPOFF_SUCCEEDED, DROPOFF_FAILED].indexOf(shipment.status) >
            -1 && (
            <AxlButton
              bg={"white"}
              compact={true}
              onClick={() => this.setState({ showFeedback: true })}
            >
              {`Feedback`}
            </AxlButton>
          )}
          <AxlButton
            bg={"white"}
            compact={true}
            onClick={this.download("PDF")}
            source={images.icon.label}
          >
            {`Full Label`}
          </AxlButton>
          <div style={styles.groupButtons}>
            <AxlButton
              bg={"white"}
              compact={true}
              style={{
                margin: "0px -1px",
                padding: "0 0 0 6px",
                width: "85px",
              }}
            >
              {shipment.tracking_code}
            </AxlButton>
            <AxlButton
              onClick={() => openTrackingLink(shipment.tracking_code)}
              bg={"gray"}
              compact={true}
              source={images.icon.track}
              style={{ margin: "0px -1px", padding: "0 5px 0 0" }}
            >
              Track
            </AxlButton>
          </div>
          {allowClone && (
            <AxlButton
              bg={"borBluish"}
              compact={true}
              onClick={() => this.setState({ showClone: true })}
            >
              {`Clone`}
            </AxlButton>
          )}
          {isAvaiableCancel && (
            <AxlPopConfirm
              trigger={
                <AxlButton
                  disabled={
                    shipment.status && shipment.status.startsWith("CANCELLED")
                  }
                  bg={"red2"}
                  compact
                >{`Cancel`}</AxlButton>
              }
              titleFormat={<div>{`CANCEL DELIVERY`}</div>}
              textFormat={
                <div>{`This is an irreversible action, are you sure cancel?`}</div>
              }
              okText={`OK`}
              onOk={this.showCancelShipmentModal}
              cancelText={`Cancel`}
              onCancel={this.hideCancelShipmentModal}
            />
          )}
        </E.FooterContainer>
        { stop_images.length > 0 && (
          <ShipmentPODModal
            open={showShipmentPicture}
            onClose={() => this.setState({ showShipmentPicture: false })}
            stop_images={stop_images}
            selectedStop={dropoff}
          />
        )}
        {showSignaturePicture && stop_signatures.length > 0 && (
          <AxlModal
            onClose={() => this.setState({ showSignaturePicture: false })}
            style={styles.modalStyle}
            containerStyle={styles.modalContainer}
          >
            <div style={styles.wrapImages}>
              {stop_signatures && (
                <Slider {...settings}>
                  {stop_signatures.map((img, index) => (
                    <div>
                      <div style={{ height: "100%" }} key={index}>
                        <img src={img.data} style={styles.imageShipment} />
                      </div>
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </AxlModal>
        )}
        {showCancelShipment && (
          <AxlModal
            onClose={this.hideCancelShipmentModal}
            style={{
              ...styles.modalStyle,
              ...styles.modalImageStyle,
              ...styles.modalShipmentCancel,
            }}
            containerStyle={styles.modalContainer}
          >
            <ShipmentCancel
              shipment={shipment}
              onClose={this.hideCancelShipmentModal}
            />
          </AxlModal>
        )}
        {showFeedback && (
          <AxlModal
            onClose={this.hideFeedbackModal}
            loading={true}
            style={{
              ...styles.modalStyle,
              ...styles.modalImageStyle,
              ...styles.modalFeedback,
            }}
            containerStyle={styles.modalContainer}
          >
            <ShipmentFeedback
              shipment={shipment}
              onClose={this.hideFeedbackModal}
            />
          </AxlModal>
        )}
        {showClone && (
          <AxlModal
            onClose={this.hideCloneModal}
            loading={true}
            style={{
              ...styles.modalStyle,
              ...styles.modalImageStyle,
              ...styles.modalFeedback,
            }}
            containerStyle={styles.modalContainer}
          >
            <ShipmentClone shipment={shipment} onClose={this.hideCloneModal} />
          </AxlModal>
        )}
      </div>
    );
  }
}

export default ShipmentDetail;

function SliderPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      style={{ ...styles.arrowButton, ...styles.arrowPrev }}
      onClick={onClick}
    >
      <i style={styles.arrowIcon} className="fa fa-angle-left" />
    </div>
  );
}

function SliderNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      style={{ ...styles.arrowButton, ...styles.arrowNext }}
      onClick={onClick}
    >
      <i style={styles.arrowIcon} className="fa fa-angle-right" />
    </div>
  );
}
